import { ApprovalStatus } from './user-dto';

export interface AdminVendorListRequestDto {
  isActive: boolean;
}

export interface AdminVendorListResponseDto {
  id: string;
  isActive: boolean;
  name: string;
  type: string;
  approvalStatus: ApprovalStatus;
}

export enum OrganizationType {
  Unknown = 'Unknown',
  Brand = 'Brand',
  Distributor = 'Distributor',
  SingleProductManufacturer = 'SingleProductManufacturer',
  MultiProductManufacturer = 'MultiProductManufacturer',
  Merchant = 'Merchant',
  Ambassador = 'Ambassador',
  System = 'System',
}

export enum OrganizationWorkAtType {
  CannabisDispensary = 'CannabisDispensary',
  CannabisDelivery = 'CannabisDelivery',
  LoungeClub = 'LoungeClub',
  CBDStore = 'CBDStore',
  SmokeVapeStore = 'SmokeVapeStore',
  BrandAmbassador = 'BrandAmbassador',
}

export interface OrganizationWorkAtTypeDto {
  id: string;
  name: OrganizationWorkAtType;
}

export interface OrganizationCountsDto {
  total: number;
  brandCount: number;
  distributorCount: number;
  merchantCount: number;
  ambassadorCount: number;
}
